
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import { Label } from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";
import {
  GridColDef,
  GridValidRowModel,
  GridAlignment,
  GridCellParams,
  GridColumnVisibilityModel
} from "@mui/x-data-grid-pro";
import { TableHeaderProps } from "../../../../../utils/types";
import useAssetTableJson from "../../../../../json/useAssetTableJson";

import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import TextArea from "../../../../../stories/TextArea/TextArea";
import Close from "../../../../../images/Close.svg"
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import useLabels from "../../../../../customHooks/useLabels";
const Data = [
  {
    date: "12-03-2024",
    order_no: "34567",
    order_to_supplier: "fg"
  }
];
interface props{
    setModalFlag:React.Dispatch<React.SetStateAction<boolean>>
}

const View = ({setModalFlag}:props) => {
  const { Purchase } = useAssetTableJson();
  
  const dynamicHeaders: TableHeaderProps[] = Purchase.PurchaseOrder.MrfToPo.filter((header)=>header.field !== "actions").map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
   
    })
  );

  const columns: GridColDef[] = [...dynamicHeaders];
  const rows: GridValidRowModel[] = [
    {
      id: 1, // Ensure the ID is unique
      approved_mrf_no: "",
      mrf_date: "",
      mrf_sl_no: "",
      item_desc: 0,
      warranty: 0,
      qty: 0,
      rate: 0,
      other_charges: 0,
      taxable_rate: 0,
      tax_perc: 0,
      total: 0,
      any_installation: 0,
      net_total: 0,
      actions: 0
    },
    ...(Data || []).map((data, index) => {
      return {
        id: index + 2, // Start IDs from 2
        approved_mrf_no: data.date,
        mrf_date: data.order_no,
        mrf_sl_no: data.order_to_supplier,
        item_desc: 0,
        warranty: 0,
        qty: 0,
        rate: 0,
        other_charges: 0,
        taxable_rate: 0,
        tax_perc: 0,
        total: 0,
        any_installation: 0,
        net_total: 0,
        actions: 0
      };
    })
  ];

  const getRow = () => {
    if (Data.length) {
      return [
        {
          id: [],
          approved_mrf_no: [],
          mrf_date: [],
          mrf_sl_no: [],
          item_desc: [],
          warranty: "Total",
          qty: 0,
          rate: 0,
          other_charges: 0,
          taxable_rate: 0,
          tax_perc: [],
          total: 0,
          any_installation: 0,
          net_total: 0,
          actions: []
        }
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow()
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "other_charges":
        case "rate":
        case "qty":
        case "taxable_rate":
        case "total":
        case "any_installation":
        case "net_total":
          return "total-count";
        case "warranty":
          return "total";
        default:
          return "hide-td";
      }
    }

    return "";
  };



  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.MRF_TO_PO_VIEW
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.MRF_TO_PO_VIEW,
      JSON.stringify(newModel)
    );
  };
  const {ledgerLabel}=useLabels();
  return (
    <>
     
      <div className="mrf-to-po-view">
        <div className="mrf-to-po-view__title">
        <Title>View Details</Title>
        <img src={Close} alt="" onClick={()=>setModalFlag(false)} />
        </div>
        <div className="mrf-to-po__details row g-0">
          <div className="col mrf-to-po__details--frame">
            <div className="label-grid">
              <Label>Purchase Order No.</Label>
              <Input disabled />
              <Label>Choose {ledgerLabel}</Label>
              <div className="mrf-to-po__details--frame--flex">
           
<Input disabled/>              </div>
            </div>
            <div className="mrf-to-po__details--frame--grid">
              <Label>GSTIN No.</Label>
              <Input disabled />

              <Label>City</Label>
              <Input disabled />
            </div>
          </div>
          <div className="col mrf-to-po__details--frame">
            <div className="label-grid">
              <Label>Date</Label>
              <Input type="date" disabled />
            </div>
          </div>
        </div>
        <div className="mrf-to-po__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
         columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel
              }
            }}
            getCellClassName={getCellClassName}
            pinnedRows={pinnedRows}
            getRowClassName={(params) =>
              params.row.id === 1 ? "mrf-to-po__tableblock--edit-row" : ""
            }
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <div className="mrf-to-po__terms row g-0">
          <div className="col">
            <div className="label-grid">
              <Label>Terms</Label>
              <TextArea rows={2} disabled/>
            </div>
          </div>
          <div className="col">
            <div className="label-grid">
              <Label>Terms</Label>
              <Input disabled/>
            </div>
          </div>
        </div>
        <Button mode="cancel" onClick={()=>setModalFlag(false)}/>
        
      </div>

    </>
  );
};

export default View;

